"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TerminalSettingsService = void 0;
const axios_1 = __importDefault(require("axios"));
const utils_1 = require("../../../utils/tsUtils/utils");
var JSONbig = require('json-bigint')({ useNativeBigInt: true });
class TerminalSettingsService {
    constructor(baseUrl) {
        this.baseUrl = baseUrl;
    }
    fetch(outlet_id) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                let header = (0, utils_1.getHeader)();
                let url = this.baseUrl + 'business/terminal/terminal_application_setting?outlet_id=' + outlet_id;
                const response = yield axios_1.default.get(url, {
                    transformResponse: [
                        (data, headers) => {
                            return JSONbig.parse(data);
                        },
                        ...axios_1.default.defaults.transformResponse,
                    ],
                    headers: header,
                    validateStatus: function (status) {
                        if (status == 404) {
                            return true;
                        }
                        return status >= 200 && status < 300;
                    },
                });
                const responseData = yield response.data.data;
                return responseData;
            }
            catch (err) {
                throw new Error("Failed to fetch terminal settings");
            }
        });
    }
    create(payload) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                let header = (0, utils_1.getHeader)();
                let url = this.baseUrl + 'business/terminal/terminal_application_setting/create';
                payload = JSONbig.stringify(payload);
                const response = yield axios_1.default.post(url, payload, {
                    transformResponse: [
                        (data, headers) => {
                            return JSONbig.parse(data);
                        },
                        ...axios_1.default.defaults.transformResponse,
                    ],
                    headers: header,
                });
                const responseData = yield response.data.message;
                return responseData;
            }
            catch (err) {
                throw new Error("Failed to create terminal settings");
            }
        });
    }
    update(payload) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                let header = (0, utils_1.getHeader)();
                let url = this.baseUrl + 'business/terminal/terminal_application_setting/edit';
                payload = JSONbig.stringify(payload);
                const response = yield axios_1.default.put(url, payload, {
                    transformResponse: [
                        (data, headers) => {
                            return JSONbig.parse(data);
                        },
                        ...axios_1.default.defaults.transformResponse,
                    ],
                    headers: header,
                });
                const responseData = yield response.data.message;
                return responseData;
            }
            catch (err) {
                throw new Error("Failed to update terminal settings");
            }
        });
    }
}
exports.TerminalSettingsService = TerminalSettingsService;
